export const ActionTypes = {
  SET_NOTIFICATION_TEMPLATES: 'SET_NOTIFICATION_TEMPLATES'
};
